import { React, Component } from 'react'
import { IoIosArrowBack } from 'react-icons/io';
import { Link, Redirect, withRouter } from 'react-router-dom';
import InputMask from "react-input-mask";

// Images
import VisaImage from './visa.png';
import MasterCardImage from './mastercard.png';
import EloImage from './elo.png';
import HipercardImage from './hipercard.png';
import creditCardValidate from '../../actions/creditCardValidate';
import ApiSso from '../../actions/sso';
import LoadingComponent from '../LoadingComponent/LoadingComponent';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css'
import Api from '../../actions/api';

class ChangePaymentCreditCard extends Component {
    
    constructor(props){
        super(props);

        this.state = {
            isLoading: false,
            step: 3,
            cardNumber: '',
            cardName: '',
            cardDate: '',
            expMonth: '',
            expYear: '',
            cardCVV: '',

            errorCardNumber: false,
            errorCardDate: false,
            errorCardCVV: false,
            errorCardName: false,

            cpf: localStorage.getItem("cpf"),
            validated: {
                'status': false,
            }
        }

        this.handleCardNumber = this.handleCardNumber.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleExpirationDate = this.handleExpirationDate.bind(this);
        
        this.validateForm           = this.validateForm.bind(this);

    }

    handleExpirationDate(event) {
        let expirationDate = event.target.value;
        let arrExpirationDate = expirationDate.split('/');

        this.setState({ 
            cardDate: event.target.value,
            expMonth: arrExpirationDate[0], 
            expYear: arrExpirationDate[1]
        });
    }

    handleCardNumber(e){
        console.log(e.target.value);

        this.setState({
            cardNumber: e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
        })

        if(e.target.value.length > 4){


            // Check brand
            var cardnumber = e.target.value.replace(/[^0-9]+/g, '');

            var cards = {
                visa      : /^4[0-9]{12}(?:[0-9]{3})/,
                master : /^5[1-5][0-9]{14}/,
                // diners    : /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
                // amex      : /^3[47][0-9]{13}/,
                // discover  : /^6(?:011|5[0-9]{2})[0-9]{12}/,
                hipercard  : /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
                elo        : /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/, 
            };

            for (var flag in cards) {
                if(cards[flag].test(cardnumber)) {
                    document.getElementById(flag).classList.add("active")
                }
            }  

            console.log(cardnumber);

        }else{

            let brandsflags = document.getElementsByClassName("brand-flag")

            for(var i = 0, j = brandsflags.length; i < j; i++) {
                if(brandsflags[i].classList.contains("active")){
                    brandsflags[i].classList.remove("active")
                }
            }

        }
    }

    handleSubmit(){
        // e.preventDefault()

        this.setState({
            isLoading: true
        })

        setTimeout(() => {

        // // Formatting info
        // let formattedCardNumber = this.state.cardNumber.replace(/[^\dA-Z]/g, '');
        // let formattedCardName   = this.state.cardName;
        // let formattedDate       = this.state.cardDate;
        // let formattedCVV        = this.state.cardCVV;

        // // Add validation

        // // Sending info
        // localStorage.setItem("card_name", formattedCardName);
        // localStorage.setItem("card_number", formattedCardNumber);
        // localStorage.setItem("card_date", formattedDate);
        // localStorage.setItem("card_cvv", formattedCVV);

            this.props.history.push("/dashboard");
            window.location.reload();
            this.setState({
                isLoading: true
            })

        }, 2000);

    }

    async validateCpf(validated) {
        if (!validated.status) {
            return false;
        }
        
        ApiSso.defaults.headers.common['Authorization'] = localStorage.getItem('token');
        await ApiSso.get('person/cpf/validate/' + this.state.cpf)
        .then(response => {
            if (!response.data.data.isValid) {
                validated.status = false;
                validated.message = 'Número de cpf inválido';

                this.setState({validated: validated});
            } else {
                validated.status = true;

                this.setState({validated: validated});
            }   
        });

    }

    handlePayment(){     

        Api.defaults.headers.common['Authorization'] = localStorage.getItem('token');
        Api.post('/payment/change' , {

            "transactionType":"credit",
            "cart": localStorage.getItem('cart'),
            "installments":"1",
            "cardNumber": this.state.cardNumber,
            "cardHolder": this.state.cardName,
            "expMonth": this.state.expMonth,
            "expYear": this.state.expYear,
            "securityCode": this.state.cardCVV,
            "email": localStorage.getItem('email')

        }).then(responsePayment => {

            console.log('Response:' + responsePayment)

            this.setState({isLoading: false});
            localStorage.setItem('payment-success', true);
            this.props.history.push("/dashboard");

            toastr.options = {
                positionClass : 'toast-top-full-width',
                hideDuration: 300,
                timeOut: 60000
            }

            toastr.clear();
            setTimeout(() => toastr.success(`Forma de pagamento alterada com sucesso.`), 300);

        }).catch(error => {

            console.log(error);
            this.setState({isLoading: false});
            
            toastr.options = {
                positionClass : 'toast-top-full-width',
                hideDuration: 300,
                timeOut: 60000
            }
            toastr.clear()
            setTimeout(() => toastr.error(error), 300)

        });
        
    }

    async validateForm(e) {
        this.setState({isLoading: true});
        e.preventDefault();

        this.setState({ 
            errorCardNumber: false,
            errorCardDate: false,
            errorCardName: false,
            errorCardCVV: false
        })

        let validated = creditCardValidate.validate(
            this.state.cardNumber.replace(/[^\dA-Z]/g, ''),
            this.state.cardName,
            this.state.expMonth,
            this.state.expYear,
            this.state.cardCVV,
        );
       
        // await this.validateCpf(validated);          

        if (validated.status == false) {

            if(validated.error == 'cardNumber'){
                this.setState({ errorCardNumber: true })
            }
            if(validated.error == 'cardDate'){
                this.setState({ errorCardDate: true })
            }
            if(validated.error == 'cardCVV'){
                this.setState({ errorCardCVV: true })
            }
            if(validated.error == 'cardName'){
                this.setState({ errorCardName: true })
            }

            this.setState({isLoading: false});
            
            toastr.options = {
                positionClass : 'toast-top-full-width',
                hideDuration: 300,
                timeOut: 60000
            }
            toastr.clear()
            setTimeout(() => toastr.error(validated.message), 300)

            return;

        }

        this.handlePayment();
        // this.handleSubmit();
    }

    

    render(){

        if(!localStorage.getItem("token")){
            return (
                <Redirect to="/" />
            )
        }


        return(
            <div>
                
                <Link to="/dashboard/plan">
                    <div className="main-title">
                        <h2>Cartão de crédito</h2>
                        <p>Bandeiras Master, Visa, Hipercard e Elo</p>
                        <IoIosArrowBack />
                    </div>
                </Link>

                {this.state.isLoading ? (
                    <LoadingComponent />
                ) : (
                    <></>
                )}

                <form className="mt-3 form payment-form payment-credit-card-form" onSubmit={(e) => this.validateForm(e)}>

                    <div className="form-row">
                        <div className="brands text-end">
                            <span id="visa" className="brand-flag"><img src={VisaImage} height="18" /></span>
                            <span id="master" className="brand-flag"><img src={MasterCardImage} height="18" /></span>
                            <span id="hipercard" className="brand-flag"><img src={HipercardImage} height="18" /></span>
                            <span id="elo" className="brand-flag"><img src={EloImage} height="18" /></span>
                        </div>
                        <input type="text" className={this.state.errorCardNumber ? 'form-control error' : 'form-control'} maxLength="21" required placeholder="Número do cartão" value={this.state.cardNumber} onChange={(e) => this.handleCardNumber(e)} />
                    </div>
                    
                    <input type="text" className={this.state.errorCardName ? 'form-control error' : 'form-control'} required placeholder="Titular do cartão" value={this.state.cardName} onChange={(e) => this.setState({ cardName: e.target.value })} />
                    
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <InputMask className={this.state.errorCardDate ? 'form-control error' : 'form-control'} mask="99/99" required maskChar=" " placeholder="DD/MM" value={this.state.cardDate} onChange={(e) => this.handleExpirationDate(e)} />
                        </div>
                        <div className="col-12 col-md-6">
                            <InputMask className={this.state.errorCardCVV ? 'form-control error' : 'form-control'} mask="9999" required maskChar=" " placeholder="CVV" value={this.state.cardCVV} onChange={(e) => this.setState({ cardCVV: e.target.value })} />
                        </div>
                    </div>                        

                    <div className="row justify-content-center">
                        <input type="submit" className="form-submit" value="Assinar agora" />
                    </div>

                </form>



            </div>
        )
    }
}

export default withRouter(ChangePaymentCreditCard)